import { callMBankBridge } from 'shared/lib/mbank-bridge'

export const openExternalUrl = (url?: string, onError?: () => void) => {
  if (!url) return

  void callMBankBridge('external.open', { url }).then((response) => {
    if (response.ok) return

    if (!window.open(url, '_blank')) onError?.()
  })
}
